// import store from './store'
export default {
  install: (app) => {
    app.config.errorHandler = (err, vm, info) => {
      // store.commit('ADD_LOGS', {
      //   type: 'error',
      //   message: err.message,
      //   stack: err.stack,
      //   info
      // })
      
      // 记录错误到控制台
      if (process.env.NODE_ENV === 'development') {
        console.group('>>>>>> 错误信息 >>>>>>')
        console.log(info)
        console.groupEnd();
        console.group('>>>>>> Vue 实例 >>>>>>')
        console.log(vm)
        console.groupEnd();
        console.group('>>>>>> Error >>>>>>')
        console.log(err)
        console.groupEnd();
      } else {
        // 生产环境只记录错误，不显示详细信息
        console.error('Vue Error:', err.message, info);
      }
      
      // 防止错误导致应用崩溃
      // 注意：Vue 3 的错误处理器默认不会阻止错误传播
      // 但我们可以通过返回 false 或使用其他机制来防止某些错误
      // 对于运行时错误，最好的方式是在组件层面进行防护
      
      // 如果是开发环境，可以选择阻止默认的错误显示
      // 但这可能会隐藏有用的调试信息，所以只在必要时使用
      // return false; // 阻止默认的错误处理
    }
    
    // 添加全局属性错误处理
    app.config.warnHandler = (msg, vm, trace) => {
      // 可以在这里处理警告
      if (process.env.NODE_ENV === 'development') {
        console.warn('Vue Warning:', msg, trace);
      }
    }
  }
}
